import { z } from "zod";
import { apiLegacy } from "../api-legacy";

const searchUsersResponseSchema = z.array(
  z.object({
    user: z.object({
      id: z.number(),
      first_name: z.string(),
      last_name: z.string(),
    }),
  }),
);

export const userService = {
  async getUsersByCompanyId({
    companyId,
  }: {
    companyId: number;
  }): Promise<z.infer<typeof searchUsersResponseSchema>> {
    try {
      const response = await apiLegacy.get(`/v1/users?league_id=${companyId}`);

      const parsedData = searchUsersResponseSchema.parse(
        response.data._embedded.users,
      );

      return parsedData;
    } catch (error) {
      return [];
    }
  },
};
